var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-layout-content-wrapper"},[_c('div',{staticClass:"absolute-wrapper"},[_c('div',{staticClass:"relative-wrapper"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{staticClass:"router-view"})],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }